import API from "../services/apiservices";

async function getid() {
  await API.getLocalDBDocument("marcasStore").then((doc) => {
    if (doc && doc.data.Success) {
      return doc.data.Data[0].id;
    } else {
      return 0;
     }
  });
}


export default {
  namespaced: true,
  namespace: "mascasStore",

  state: {
    storename: "marcasStore",
    marcas: {
      id: 0,
      api: null,
      data: [],
      error: null
    },
  },

  getters: {
    gtxStore: () => ({name: "marcasStore", route: "Servicos/Marcas/Get", setter: "setmarcas"}),
    gtxMarcas: (state) => state.marcas,
    gtxMarcas_data: (state) => state.marcas.data || [{id: 1}], // coloco id: 1 para fixar uma marca padrão
    gtxMarcas_GetById: (state) => (id) => state.marcas.data.find(f => f.id == id) || {value: 0, text: ""},
    gtxMarcas_selected: (state, getters) => state.marcas.data.find(f => f.id == getters.gtxMarcas_id),
    gtxMarcas_dataoptions: (state) => state.marcas.data ? state.marcas.data.filter(f=>!f.K1Export).map(o=>({value: o.id, text: o.reduzido})).sort((a, b) => a.text.localeCompare(b.text)) : [],
    gtxMarcas_id: (state) => state.marcas.id,
    gtxMarcas_reduzido: (state, getters) => {
      const data = state.marcas.data.find(f => f.id == getters.gtxMarcas_id);
      return data ? data.Reduzido : "";
    },
    gtxMarcas_error: (state) => state.marcas.error,
    gtxMarcas_defaultid: (state, getters) => getters.gtxMarcas_data[0].id,
    gtxMarcas_EmailComercial: (state, getters) => [...new Set(getters.gtxMarcas_data.filter(e=>e.EmailMarcas.length).map(e=>e.EmailMarcas).flat().filter(f=>f.Tipo=="COMERCIAL").map(m=>m.eMail))],
    gtxMarcas_EmailFinanceiro: (state, getters) => [...new Set(getters.gtxMarcas_data.filter(e=>e.EmailMarcas.length).map(e=>e.EmailMarcas).flat().filter(f=>f.Tipo=="FINANCEIRO").map(m=>m.eMail))],
    gtxMarcas_EmailLogistica: (state, getters) => [...new Set(getters.gtxMarcas_data.filter(e=>e.EmailMarcas.length).map(e=>e.EmailMarcas).flat().filter(f=>f.Tipo=="LOGISTICA").map(m=>m.eMail))],
    gtxMarcas_EmailTI: (state, getters) => [...new Set(getters.gtxMarcas_data.filter(e=>e.EmailMarcas.length).map(e=>e.EmailMarcas).flat().filter(f=>f.Tipo=="TI").map(m=>m.eMail))],
  },

  mutations: {
    setmarcas: (state, marcas) => (state.marcas = {id: marcas.data[0].id, api: marcas.apiresponse, data: marcas.data, error: null}),
    setmarcasid: (state, id) => (state.marcas.id = id),
    setmarcasdata: (state, data) => (state.marcas.data = data),
  },

  actions: {
    actMarcasGet({ commit, getters }) {
      
      // tem que definir um getter com os dados da store conforme o exemplo:
      // gtxStore: () => ({name: "marcasStore", route: "Servicos/marcas/Get", setter: "setmarcas"}),

      // verifica a última atualização da store ...
      return new Promise((res, rej) => {
        try {
          // console.log(new Date().toTimeString().substring(0, 8), "- Carregando", getters.gtxStore.name);
          API.get("Servicos/Stores/Get", {StoreName: getters.gtxStore.name}, false).then((apidata) => {
            let storeUpdate = new Date('02/12/2022'); // para quando não houver data de atualiação da store gravada
            let localUpdate = new Date('01/12/2022');
            const data = API.prepareData(apidata.data);
            if (data.success) {
              storeUpdate = new Date(data.data[0].Updated);
            }
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc) localUpdate = doc.data.updated;
              if (localUpdate > storeUpdate) {
                commit(getters.gtxStore.setter, doc.data);
                res(doc.data);
              } else {
                API.get(getters.gtxStore.route, {}, false).then((apidata) => {
                  const data = API.prepareData(apidata.data);
                  commit(getters.gtxStore.setter, data);
                  API.setLocalDBDocument({ data: data }, getters.gtxStore.name);
                  res(data);
                }).catch((error) => {
                  API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
                    if (doc && doc.data) {
                      commit(getters.gtxStore.setter, doc.data);
                      res(doc.data);
                    } else {
                      const emptyData = { data: [], id: 0, error: error.message };
                      res(emptyData);
                    }
                  });
                });
              }
            });
          }).catch((error) => {
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc && doc.data) {
                commit(getters.gtxStore.setter, doc.data);
                res(doc.data);
              } else {
                const emptyData = { data: [], id: 0, error: error.message };
                res(emptyData);
              }
            });
          });
        } catch (err) { rej(err); } });

    },
    actmarcasMudaMarca({ commit, getters }, id) {
      const data = getters.gtxMarcas_data.find(f => f.id == id);
      if (data) {
        commit("setmarcasid", data.id);
      }
    }
  },
};
